import Home from './components/Home';
import 'bootstrap/dist/css/bootstrap.css';

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
